import { FC } from "react";
import clsx from "clsx";

import { AncetViewItem } from "../../lib/ancet";

import styles from "./AncetTable.module.scss";

type AncetTableProps = {
  items: AncetViewItem[];
  className?: string;
};

export const AncetTable: FC<AncetTableProps> = ({
  items,
  className,
}) => {
  return (
    <div className={clsx(styles.wrapper, className)}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Текст вопроса</th>
            <th>Ответы</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.questNum}>
              <td>
                <span className={styles.question}>{item.fullTitle}</span>
              </td>
              <td>
                <span className={styles.answer}>{item.value || "—"}</span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};


















